export const homePageAr =  {
  "Utilisateurs": "المستخدمين",
  "Roles": "الأدوار",
  "Depenses": "المصاريف",
  "Produits": "المنتجات",
  "Mode de paiements": "طرق الدفع",
  "Mode de paiement": "طريقة الدفع",
  "Permissions": "الأذونات",
  "Atlas Softwares": "برامج الاطلس",
  "Statistiques": "الإحصائيات",
  "Fournisseurs": "الموردين",
  "Achats": "المشتريات",
  "Clients": "الزبناء",
  "Ventes": "المبيعات",
  "Consommations": "استهلاك",

  "Service": "الخدمات",
  
  "Vous n'etes pas autoriser a acceder a cette page": "لا يمكنك السماح بالوصول إلى هذه الصفحة",

  "Chercher": "ابحث",
"Choisissez un tableau": "اختر جدولًا",

}

